// Constants for different requests for current reducer
export default {
  shiftInfo: 'SHIFT_INFO',
  shiftStats: 'SHIFT_STATS',
  shiftStatsBySiteID: 'SHIFT_STATS_BY_SITE_ID',
};
